import { useEffect, useState } from "react";
import "./PlantationTwoHome.scss";

// import Faq from "../../../../default-components/Faq";
import ButterflyLottie from "../plantationTwoComponents/ButterflyLottie";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
// import PlantationOneCounter from "../../environmentOne/plantationOneComponents/PlantationOneCounter";
import PlantationTwoOccasions from "../plantationTwoComponents/PlantationTwoOccasions";
import BestSellersSection from "../plantationTwoComponents/BestSellersSection";
import PlantationTwoBanners from "../plantationTwoComponents/PlantationTwoBanners";
import PlantationTwoBlog from "../plantationTwoComponents/PlantationTwoBlog";
// import PlantationTwoBooking from "../plantationTwoComponents/PlantationTwoBooking";
import PlantationTwoCategories from "../plantationTwoComponents/PlantationTwoCategories";
// import PlantationTwoFooter from "../plantationTwoComponents/PlantationTwoFooter";
// import PlantationTwoHero from "../plantationTwoComponents/PlantationTwoHero";
import PlantationTwoFAQ from "../plantationTwoComponents/PlantationTwoFAQ";
import PlantationTwoOffer from "../plantationTwoComponents/PlantationTwoOffer";
// import PlantationTwoSeprator from "../plantationTwoComponents/PlantationTwoSeprator";
import PlantationTwoAboutUs from "../plantationTwoComponents/PlantationTwoAboutUs";
import PlantationTwoServices from "../plantationTwoComponents/PlantationTwoServices";
import PlantationTwoSubscription from "../plantationTwoComponents/PlantationTwoSubscription";
import PlantationTwoTestimonials from "../plantationTwoComponents/PlantationTwoTestimonials";
import PlantationTwoVideo from "../plantationTwoComponents/PlantationTwoVideo";
import PlantationTwoDecor from "../plantationTwoComponents/PlantationTwoDecor";
import BusinessThreeTeam from "../../../business/businessThree/businessThreeComponents/BusinessThreeTeam";
const PlantationTwoHome = () => {
  const { documents: dbMediaDocuments, error: dbMediaError } = useCollection(
    "media",
    ["pageName", "==", "home"]
  );

  const [faqCount, setFaqCount] = useState(0);

  // START COUNT CODE FOR FAQS
  useEffect(() => {
    if (dbMediaDocuments) {
      setFaqCount(dbMediaDocuments.length);
    }
  }, [dbMediaDocuments]);
  // END COUNT CODE FOR FAQS

  return (
    <div className="plantation-two-home">
      <ButterflyLottie />
      <PlantationTwoBanners />
      <PlantationTwoCategories />
      <PlantationTwoOccasions />
      <BestSellersSection />
      <PlantationTwoDecor />
      <PlantationTwoSubscription />
      <PlantationTwoOffer />
      {/* <PlantationTwoHero /> */}
      <PlantationTwoAboutUs />
      <PlantationTwoVideo />
      {/* <PlantationTwoBooking /> */}
      {/* <PlantationTwoSeprator1 /> */}
      <PlantationTwoServices />
      <PlantationTwoTestimonials />
      <PlantationTwoBlog />
      <BusinessThreeTeam />
      {/* <PlantationOneCounter /> */}
      {/* <BusinessOneFaq /> */}
      <PlantationTwoFAQ />
      {/* <PlantationTwoFooter /> */}
    </div>
  );
};

export default PlantationTwoHome;
